const { Button } = require('primereact/button');

export const FormFooter = ({ onSubmit, onSaveDraft }) => (
  <>
    <div className="footer-btn w-100 d-flex flex-column">
      <div className="d-flex my-2 align-items-center files-note w-100">
        <i className="pi pi-info-circle me-2"></i>
        Any changes to this form will overwrite saved information.
      </div>
      <div className="d-flex gap-2 justify-content-end">
        <Button
          type="button"
          label="Save Incomplete Form"
          className="p-button p-component p-button p-button-primary outline"
          onClick={onSaveDraft}
        />
        <Button type="submit" label="Submit" className="p-button p-component p-button p-button-success" onClick={onSubmit} />
      </div>
    </div>
  </>
);
